import { ajaxHandler } from './AjaxHandler';
import { API_KEYS } from '../config/apiKeys';

// TODO: this file no longer gets data from sparta so it can be renamed to something else
const DEFAULT_PARAMS = {
    include_travel_professionals: 'true',
    vertical_id: '5',
    is_contactable: '1',
    location: 'SW1P 3JX',
};

const buildQuery = params => {
    const parameters = params ? { ...DEFAULT_PARAMS, ...params } : DEFAULT_PARAMS;

    let separator = '?';
    return encodeURI(
        Object.keys(parameters).reduce((query, key) => {
            const reduced = `${query}${separator}${key}=${parameters[key]}`;
            separator = '&';
            return reduced;
        }, '')
    );
};

const search = params => {
    const query = buildQuery(params);
    return ajaxHandler('GET', `${API_KEYS.API_URL}/v2/public/stats${query}`);
};

const isValidResponse = response => {
    return (
        response &&
        response.data &&
        JSON.parse(response.data)?.data?.TotalProfessionals > 0
    );
};

const isNoContent = status => {
    return status === 204;
};

const getStats = params => {
    return new Promise((resolve, reject) => {
        search(params)
            .then(response => {
                if (!isValidResponse(response) || isNoContent(response.status)) {
                    resolve({
                        reviewsCount: 21,
                        averageScore: 4.4,
                        total: 1,
                    });

                    return;
                }

                const responseData = JSON.parse(response.data)?.data;
                const stats = {
                    reviewsCount: responseData?.TotalReviews,
                    averageScore: responseData?.ReviewAvg,
                    total: responseData?.TotalProfessionals,
                };

                resolve(stats);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export default getStats;
